import { cssRule } from 'typestyle';

cssRule('.tb-action-options', {
    width: '500px',
});

cssRule('.tb-action-options .tb-padded-bottom-medium', {
    paddingBottom: '12px',
});

cssRule('.tb-action-options .tb-padded-cell', {
    paddingTop: '12px',
    paddingLeft: '18px',
});

cssRule('.tb-action-options .tb-wide-button', {
    width: '100%',
});

cssRule('.tb-action-options .tb-button-desc', {
    padding: 0,
});

